import { style } from '@vanilla-extract/css';

export const wrapper = style({
  margin: '0 auto',
  width: 'fit-content',
});

export const content = style({
  marginBottom: '0.9375rem', // 15px
  fontSize: '1rem', // 16px
  lineHeight: '1.875rem', // 30px
  color: '#666',
  wordWrap: 'break-word',
  textAlign: 'center',
});

export const mainMessage = style({
  fontSize: '1.5rem', // 24px
});

export const iconWrapper = style({
  margin: '2.5rem auto 0', // 40px
  width: '11.25rem', // 180px
});
